import styled from "styled-components";

export const Label = styled.p`
  text-align: center;
`;
